import type { InferOutput } from 'valibot'
import { object, picklist, string } from 'valibot'

/**
 * Schema for shared Crystallize catalogue properties.
 *
 * @see https://crystallize.com/learn/concepts/pim/catalogue
 */
export const baseCatalogueSchema = object({
  id: string(),
  name: string(),
  path: string(),
  type: picklist([
    'document',
    'folder',
    'product',
  ]),
  shape: object({
    identifier: string(),
  }),
})

export type CrystallizeBaseCatalogue = InferOutput<typeof baseCatalogueSchema>
